import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { uniqueIdentificationGenerator } from '../../utils/uniqueIdentificationGenerator'

import errorIcon from 'images/error-icon.svg'
import ClearSVG from 'component/svgComponents/clear'

const InputCurrency = ({
  label,
  name,
  id,
  value: propValue = '',
  onChange,
  required,
  placeholder,
  disabled,
  className,
  errorMsg,
  clearIcon = true,
}) => {
  const [value, setValue] = useState(propValue || '')
  const [showError, setShowError] = useState(false)

  const inputId = id || uniqueIdentificationGenerator('input-currency_')
  const inputName = name || uniqueIdentificationGenerator('input-currency_')

  useEffect(() => {
    if (propValue !== undefined) {
      setValue(propValue)
      setShowError(false)
    }
  }, [propValue])

  const handleChange = (e) => {
    const onlyDigits = e.target.value.replace(/\D/g, '')
    const maskedValue = applyMask(onlyDigits)

    setValue(maskedValue)
    setShowError(false)

    onChange?.({ target: { value: maskedValue } })
  }

  const handleBlur = () => {
    if (required && (!value || value.trim() === '')) {
      setShowError(true)
    }
  }

  const handleClear = () => {
    setValue('')
    setShowError(false)
    onChange?.({ target: { value: '' } })
  }

  const applyMask = (digits) => {
    const cents = parseInt(digits || '0', 10)
    const reais = cents / 100

    return reais.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  }

  const invalid = showError || Boolean(errorMsg)
  const valid = !invalid && value !== ''

  return (
    <div className={`input-container ${invalid ? 'invalid' : valid ? 'valid' : ''}`}>
      {label && (
        <label htmlFor={inputId}>
          {label}
          {required !== true && <i> - opcional</i>}
        </label>
      )}

      <div className="input-wrapper">
        <input
          id={inputId}
          name={inputName}
          type="text"
          disabled={disabled}
          className={classNames('form-control', { invalid, valid }, className)}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
        />

        {clearIcon && value && (
          <ClearSVG className="clear-icon" onClick={handleClear} />
        )}
      </div>

      {(showError || errorMsg) && (
        <small className="error">
          <img src={errorIcon} alt="erro" />
          {errorMsg || 'Obrigatório'}
        </small>
      )}
    </div>
  )
}

InputCurrency.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  errorMsg: PropTypes.string,
  clearIcon: PropTypes.bool,
}

export default InputCurrency
